import { gql } from 'graphql-request';
import { merchantServiceGraphql, userToken } from '../config/Config';

export const updateTerminalStatus = async (terminalID, newStatus, password) => {
  const data = {
    updateStatusTerminalId: terminalID,
    status: newStatus,
  };

  try {
    const QUERY = gql`
      mutation UpdateStatusTerminal(
        $updateStatusTerminalId: Int!
        $status: Int!
      ) {
        updateStatusTerminal(id: $updateStatusTerminalId, status: $status) {
          id
          status
        }
      }
    `;

    const headerWithPassword = {
      authorization: userToken,
      password: password,
    };

    const response = await merchantServiceGraphql.request(QUERY, data, headerWithPassword);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getAllTerminal = async() => {
  const GET_ALL_TERMINAL = gql`
    query AllTerminals {
      allTerminals {
        id
        alias
      }
    }
  `
  const response = await merchantServiceGraphql.request(GET_ALL_TERMINAL);
  return response.allTerminals
}
 